// extracted by mini-css-extract-plugin
export var acitonButtons = "_ff-0";
export var additionalIcon = "_ff-f";
export var block = "_ff-1";
export var blockContent = "_ff-7";
export var blockDescription = "_ff-8";
export var blockIcon = "_ff-9";
export var blockTitle = "_ff-6";
export var border = "_ff-a";
export var center = "_ff-l";
export var edge = "_ff-b";
export var edgeLabel = "_ff-c";
export var edgePath = "_ff-d";
export var error = "_ff-e";
export var flowchart = "_ff-g";
export var flowchartContent = "_ff-h";
export var highlighted = "_ff-3";
export var hover = "_ff-4";
export var icon = "_ff-i";
export var left = "_ff-m";
export var navButton = "_ff-j";
export var navButtons = "_ff-k";
export var right = "_ff-n";
export var selected = "_ff-2";
export var small = "_ff-5";